<!-- BlankLayout.vue -->
<template>
  <slot/>
</template>

<script setup>
defineOptions({name: 'BlankLayout'})
</script>